var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.606445,
    y: 0.751953,
    width: 26.6953,
    height: 23.67,
    rx: 8,
    fill: "#083CB5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.913 10.7034L18.6562 11.4861C18.5224 11.8938 17.9457 11.8938 17.812 11.4861L17.5552 10.7034C17.423 10.3006 17.1071 9.98474 16.7044 9.85259L15.9216 9.59575C15.514 9.46199 15.514 8.88532 15.9216 8.75157L16.7044 8.49473C17.1071 8.36257 17.423 8.04671 17.5551 7.64395L17.812 6.8612C17.9457 6.45355 18.5224 6.45355 18.6562 6.86119L18.913 7.64395C19.0452 8.04671 19.361 8.36257 19.7638 8.49473L20.5465 8.75157C20.9542 8.88533 20.9542 9.46199 20.5465 9.59575L19.7638 9.85259C19.361 9.98474 19.0452 10.3006 18.913 10.7034Z",
    fill: "#FF427E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.123 13.0903V19.5989H17.2634V13.0903H19.123Z",
    fill: "#FFFCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20893 7.5116H12.3008L15.4345 19.5989H13.5134L12.7903 16.8095H8.71943L7.99626 19.5989H6.0752L9.20893 7.5116ZM9.20154 14.9499H12.3082L10.8619 9.37118H10.6479L9.20154 14.9499Z",
    fill: "#FFFCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLogo2);
export default __webpack_public_path__ + "static/media/ai_logo2.bfe9f97c449a3e832d03bd47b5c23bde.svg";
export { ForwardRef as ReactComponent };